import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { setTokenGetter } from '../http/client';

/**
 * Bridges Auth0 to the shared http client. Once authenticated, every
 * subsequent axios call gets a fresh bearer token resolved via
 * `getAccessTokenSilently`. While unauthenticated, requests go without a
 * token (the API will 401 — that's fine, the routes that need auth are
 * gated behind `RequireAuth`).
 *
 * Renders nothing — wire it up via a tiny <AuthTokenBridge /> component
 * that lives INSIDE Auth0Provider.
 */
export function useAuthTokenWiring(): void {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      setTokenGetter(async () => undefined);
      return;
    }
    setTokenGetter(async () => {
      try {
        return await getAccessTokenSilently();
      } catch {
        return undefined;
      }
    });
  }, [getAccessTokenSilently, isAuthenticated]);
}
